import MarketSettingsUsersSubscriptionAccessRoute from 'lumen/routes/market/settings/users/subscription-access';

export default class DestinationSettingsUsersSubscriptionAccessRoute extends MarketSettingsUsersSubscriptionAccessRoute {
  usersRouteName = 'destination.settings.users';
}
